<div class="content-wrapper">
    <mat-drawer-container [ngClass]="'mat-drawer-container-wrapper'" autosize>
        <div class="header">
            <app-header
                    [backButtonDisplayed]="true"
                    [backButtonLabel]="'GENERAL.BACK' | translate"
                    [headerText]="'CMS.HEADER_TITLE' | translate"
                    [headerParagraph]="headerDescription"
                    [leaveButton]="true"
                    [leaveButtonLabel]="'GENERAL.LOGOUT' | translate"
                    [showHeaderControls]="false"
                    [indicationTitle]="false"
                    (buttonEvent)="getBack()"
                    (leaveIndication)="leave()">
            </app-header>
        </div>
        <mat-drawer #drawer mode="side" opened="true" class="editor-outline-wrapper">
            <app-cms-menu
                    [textSize]="reviewModeTextSize"
                    [treeData]="treeData"
                    [showPrimaryMenuButton]="true"
                    [primaryMenuButtonIcon]="'add'"
                    [primaryMenuButtonText]="'GENERAL.CREATE_NEW_UNIT' | translate"
                    [currentUnitOrderId]="currentUnitOrderId"
                    [hideCloseIcon]="true"
                    (closeEvent)="closeMenu(drawer)"
                    (emitPrimaryMenuButtonEvent)="onCreateUnit()"
                    (showElementEvent)="showInformationUnit($event)"
                    (unitLevelUpEvent)="moveUnitLevelUp($event)"
                    (unitLevelDownEvent)="moveUnitLevelDown($event)"
                    (unitDeleteEvent)="deleteUnitConfirmationDialog($event)"
                    (moveUnitEvent)="reorderUnits($event)"
                    (unitRelevanceEvent)="changeUnitRelevance($event)">
            </app-cms-menu>
        </mat-drawer>
        <div class="content">
            <app-information-unit-editor
                    [language]="selectedLanguage"
                    [indicationId]="indicationId"
                    [informationUnit]="informationUnit$ | async"
                    [currentUnitOrderId]="currentUnitOrderId"
                    (changeLanguageEvent)="changeLanguage($event)"
                    (discardChangesEvent)="discardChanges()"
                    (saveInformationUnitChangesEvent)="saveChanges($event)">
            </app-information-unit-editor>
        </div>
    </mat-drawer-container>

    <app-notification></app-notification>
</div>
